import { COMPANIES } from '../constants';

// GTM reads the logged-in guest and the current booking's brand from the dataLayer (`user`, `booking`).
// It used to read them from localStorage through Custom JavaScript variables, which the page's
// Content-Security-Policy refuses because GTM runs them with eval. base.html.twig pushes the stored
// values before GTM starts, so tags firing on page load see them; syncGtmData keeps them current.

/** The guest fields GTM tags use (Intercom identity, GA4 user properties), or null when logged out. */
export const gtmUser = user => (user ? {
  id: user.id ?? null,
  email: user.email ?? null,
  firstName: user.firstName ?? null,
  intercomHash: user.intercomHash ?? null
} : null);

/** 'YNF' or 'TYW' for the booking's brand, null when there is no booking. Mirrors localStorage.currentBooking. */
export const gtmBookingCompany = booking => {
  const companyId = booking?.week?.company?.id;
  if (!companyId) {
    return null;
  }
  return companyId === COMPANIES.YNF ? 'YNF' : 'TYW';
};

const pushToDataLayer = data => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

let lastUserKey;
let lastCompany;

/**
 * Pushes `user` and `booking.company` to the dataLayer when they change. The company is kept after the
 * booking is cleared, as localStorage.currentBooking was, so tags firing later still see the last brand.
 */
export const syncGtmData = state => {
  const user = gtmUser(state.user?.loggedUser);
  const userKey = JSON.stringify(user);
  if (userKey !== lastUserKey) {
    lastUserKey = userKey;
    pushToDataLayer({ user });
  }

  const company = gtmBookingCompany(state.booking?.currentBooking);
  if (company && company !== lastCompany) {
    lastCompany = company;
    pushToDataLayer({ booking: { company } });
  }
};

/** Test helper: forget what was last pushed. */
export const resetGtmDataSync = () => {
  lastUserKey = undefined;
  lastCompany = undefined;
};
